<template>
  <div v-if="!!$store.getters.getNotifications.length" class="notification-cnt">
    <transition-group
      name="appera"
      tag="ul"
      class="info"
      v-on:before-enter="beforeEnter"
      v-on:before-leave="beforeLeave"
    >
      <NotificationListItem
        v-for="item in getList"
        :key="item.text"
        :item="item"
        :showOne="showOne"
      />
    </transition-group>
    <a href="#" class="notification__btn primary" @click.prevent="toggleList">{{
      showOne ? $t("Mostra tutte le notifiche") : $t("Raggruppa le notifiche")
    }}</a>
  </div>
</template>

<script>
import NotificationListItem from "./NotificationListItem";

export default {
  name: "InformationList",
  components: {
    NotificationListItem
  },
  data() {
    return {
      showOne: true,
      ind: 0
    };
  },
  computed: {
    getList() {
      if (this.showOne) {
        return [this.$store.getters.getNotifications[0]];
      } else {
        return this.$store.getters.getNotifications;
      }
    }
  },
  created() {
    if (this.$route.path.includes("notifications")) {
      this.showOne = false;

      if (!this.$store.getters.getNotifications.length) {
        this.$store.commit("showSpinner");
        this.$store.dispatch("fetchNotifications").then(() => {
          this.$store.commit("hideSpinner");
        });
      }
    }
  },
  methods: {
    toggleList() {
      this.showOne = !this.showOne;
    },
    beforeLeave(el) {
      el.style.transitionDelay =
        (1 / this.$store.getters.getNotifications.length) * this.ind + "s";
      this.ind--;
    },
    beforeEnter(el) {
      el.style.transitionDelay =
        (1 / this.$store.getters.getNotifications.length) * this.ind + "s";
      this.ind++;
    }
  }
};
</script>
<style lang="scss">
.notification-cnt {
  margin-bottom: 90px;
  @media (min-width: 767px) {
    margin-bottom: 20px;
  }
}

.notification__btn {
  display: none;
  @media (min-width: 767px) {
    text-align: center;
    display: block;
    font-weight: bold;
    font-size: 13px;
  }
}

.notification__item.appera-enter,
.notification__item.appera-leave-to {
  transform: translateX(-300px);
  opacity: 0;
  height: 0px;
  padding: 0;
}

.notification__item.appera-enter-active,
.notification__item.appera-leave-active {
  transition: 1s all;
}

.notification__item.appera-enter-to,
.notification__item.appera-leave {
  transform: translateX(0);
  opacity: 1;
  height: 110px;
  padding: 15px;
  padding-top: 25px;
}
</style>
